export const areasOfExpertiseFilter = (): void => {
  const allAreasOfExpertiseBlocks = document.querySelectorAll('.js-areasofexpertise') as unknown as HTMLElement[]

  allAreasOfExpertiseBlocks.forEach((areaOfExpertiseBlock: HTMLElement) => {
    const allFilterTrigers = areaOfExpertiseBlock.querySelectorAll('.js-areasofexpertise-soloFilter') as unknown as HTMLElement[]

    allFilterTrigers.forEach((triggerElement: HTMLElement) => {
      triggerElement.addEventListener('click', (): void => {
        const filterValue = triggerElement.dataset.filterTarget as unknown as string

        const allEmployees = areaOfExpertiseBlock.querySelectorAll('.js-employees-singleEmployee') as unknown as HTMLElement[]
        allEmployees.forEach((employee: HTMLElement) => {
          // @ts-ignore
          const tagIDS = JSON.parse(employee.dataset.singleEmployeeTags)
          const stringTags: string[] = tagIDS.map((tagID: number) => {
            return tagID.toString()
          })
          if (stringTags.includes(filterValue) || filterValue === 'all') {
            employee.style.display = 'block'
          }
          else {
            employee.style.display = 'none'
          }
        })

        const allOffices = areaOfExpertiseBlock.querySelectorAll('.js-offices-singleOffice') as unknown as HTMLElement[]
        allOffices.forEach((office: HTMLElement) => {
          // @ts-ignore
          const tagIDS = JSON.parse(office.dataset.singleOfficeTags)
          const stringTags: string[] = tagIDS.map((tagID: number) => {
            return tagID.toString()
          })
          if (stringTags.includes(filterValue) || filterValue === 'all') {
            office.style.display = 'block'
          }
          else {
            office.style.display = 'none'
          }
        })

        allFilterTrigers.forEach((tagElement: HTMLElement) => {
          tagElement.classList.remove('-active')
        })
        triggerElement.classList.add('-active')
      })
    })
  })
}
